<template>
  <div>
    <b-card>
      <b-row class="mb-1">
        <b-col md="4">
          <b-form-input v-model="filter.name" v-on:keyup.enter="GetStructureSalary()" placeholder="Cari" />
        </b-col>
        <b-col class="text-right">
          <b-button variant="primary" @click="AddSalary()" v-ripple.400="'rgba(255, 255, 255, 0.15)'">
            Tambah
          </b-button>
        </b-col>
      </b-row>

      <BaseTable
        :fields="fields"
        :items="items"
        :loading="loading"
        :rows="pagination.total"
        :perPage="filter.size"
        :hideView="true"
        :edit-item="editItem"
        :delete-item="deleteItem"
        :handle-page-change="handlePageChange"
        :currentPage="filter.page"
      />
    </b-card>
  </div>
</template>
<script>
import _ from "lodash";
import Ripple from "vue-ripple-directive";
import BaseTable from "@/components/BaseTable.vue";
import { BCard, BRow, BCol, BButton, BFormInput } from "bootstrap-vue";
import { ValidationProvider, ValidationObserver } from "vee-validate";
import { ComponentStructureSalaryServices } from '../../services/component-salary.service'
import { successNotification, errorNotification } from "@/auth/utils";
import utility from '../../libs/utility'
export default {
  name: "MasterSalaryStructure",
  components: {
    BaseTable,
    BCard,
    BRow,
    BCol,
    BButton,
    BFormInput
  },
  directives: {
    Ripple
  },
  data() {
    return {
      pageTitle: 'Master Salary Structure',
      fields: [
        {
          key: "no",
          label: "No"
        },
        {
          key: "name",
          label: "Nama"
        },
        {
          key: "code",
          label: "Kode"
        },
        {
          key: "actions",
          label: "Aksi"
        }
      ],
      items: [],
      loading: false,
      pagination: {
        total: 0
      },
      filter: {
        name: "",
        page: 1,
        size: 10
      },
    }
  },
  watch: {
    'filter.page': function () {
      this.GetStructureSalary();
    }
  },
  methods: {
    AddSalary() {
      this.$router.push('/structure-salary/salary/add');
    },
    editItem(items) {
      this.$router.push(`/structure-salary/edit/${items.salaryStructureId}`);
    },
    handlePageChange(value) {
      this.loading = true
      this.filter.page = value;
    },
    deleteItem(items) {
      window.console.log(items);
      this.$swal({
        title: "Anda yakin?",
        text: "Anda yakin ingin menghapus data ini?",
        icon: "warning",
        showCancelButton: true,
        customClass: {
          confirmButton: "btn btn-primary",
          cancelButton: "btn btn-outline-danger ml-1",
        },
        buttonsStyling: false,
      }).then(async (result) => {
        if (result.isConfirmed) {
          this.loading  =  true;
          await ComponentStructureSalaryServices.delete(items.salaryStructureId)
            .then((data) => {
              window.console.log(data);
              if (utility.ResponseCode02(data)) {
                this.loading  =  false;
                successNotification(this,"Success");
                this.GetStructureSalary();
              }
            })
            .catch((e) => {
              errorNotification(this, "Oops!", e.message);
              this.loading  =  false;
            });
        }
      });
    },
    async GetStructureSalary() {
      this.loading = true;
      let req = {
        page: this.filter.page,
        size: this.filter.size,
        name: this.filter.name
      };
      await ComponentStructureSalaryServices.findAll(req)
        .then((result) => {
          window.console.log(result);
          this.items  = [];
          if (utility.ResponseCode02(result)) {
            result.data.content.forEach((items) => {
              items['name'] = items.name;
              items['code'] = items.code;
              this.items.push(items);
            });
            window.console.log(this.items);
            this.pagination.total = result.data.total;
          }
          this.loading = false;
        })
        .catch((e) => {
          errorNotification(this, "Oops!", e.message);
          this.loading = false;
        })
    }
  },
  mounted() {
    this.GetStructureSalary();
  }
}
</script>
